export enum Dir {
  XX,
  RX,
  TX,
}

export namespace Dir {
  export function getDefaultSyncManager(dir: Dir) {
    const value = Dir[dir]

    if (value === 'XX') {
      return 0
    }

    return value === 'RX' ? 2 : 3
  }

  /** XML tag of an SDO list for this direction, as written to master.xml and the SDO export */
  export function sdoTag(dir: Dir) {
    return dir === Dir.RX ? 'RxSdo' : 'TxSdo'
  }

  /** Object key of the parsed SDO list (xml2js firstCharLowerCase applied to sdoTag) */
  export function sdoKey(dir: Dir) {
    const tag = sdoTag(dir)
    return tag.charAt(0).toLowerCase() + tag.slice(1)
  }

  /** Link type used by the importers for parameters in this direction */
  export function linkType(dir: Dir) {
    return dir === Dir.RX ? 'input' : 'output'
  }

  export function list() {
    return [
      {
        name: 'rx',
        value: Dir.RX,
      },
      {
        name: 'tx',
        value: Dir.TX,
      },
    ]
  }
}
